import { GoToCreateIncident } from '../../packages/dialogs/create-incident/create-incident'
import { getNamespaces } from './index'
import { getDocument } from '../../common/dom-helpers'
import { getDialogService } from '../dialog/public-facade'
import { hasResolveFeatureFlag } from '../pbx-feature-flags/pbx-feature-flags'
import { hasUnifiedAdminPermission } from '../identity/permissions'

export const RESOLVE_NAMESPACE = 'resolve'

export interface ResolveNamespace {
  readonly commands: {
    openCreateIncidentDialog(): void
  }
}

export const setupResolveCommands = async () => {
  const resolveNamespace = getNamespaces().retrieve<ResolveNamespace>(RESOLVE_NAMESPACE)

  if (hasUnifiedAdminPermission()) {
    const isResolveFeatureEnabled = await hasResolveFeatureFlag()

    if (isResolveFeatureEnabled) {
      resolveNamespace.commands.openCreateIncidentDialog.addHandler(() => {
        getDialogService().open(getDocument().createElement(GoToCreateIncident.tagName))
      })
    }
  }
}
